export default __webpack_public_path__ + "static/media/addBlue.94d3f3de.svg";